import { useId } from 'react';
import { Icon } from '@nazka/nazka.mapframe.components';

import InfoIcon from '@App/components/InfoIcon/InfoIcon';
import theme from '@style/theme.json';

import './indicator-card.css';

function IndicatorCard({
  label,
  color,
  icon,
  value,
  suggestedAction,
  tooltip,
  backgroundColor = theme.color['common'].white,
  valueBackgroundColor = theme.color['info-light'],
  valueColor,
}) {
  const id = useId();

  return (
    <div className="indicator-card" style={{ backgroundColor }}>
      <div className="indicator-card__header">
        <div className="indicator-card__header__title">
          <Icon css={{ backgroundColor: color }} color="white" className="indicator-card__header__icon" icon={icon} />
          <h3>{label}</h3>
        </div>
        <InfoIcon
          id={`${id}-tooltip`}
          className="indicator-card__header__info"
          tooltip={tooltip}
          size="22px"
          type="filled"
          color={theme.color.primary.main}
        />
      </div>
      <div className="indicator-card__body">
        <div className="indicator-card__body__action">
          <strong>Suggested action:</strong>
          <p>{suggestedAction}</p>
        </div>
        <div className="indicator-card__body__value" style={{ backgroundColor: valueBackgroundColor }}>
          <span className="indicator-card__body__value__number">{Number(value).toFixed(1)}</span>
          <span className="indicator-card__body__value__dot" style={{ backgroundColor: valueColor }} />
        </div>
      </div>
    </div>
  );
}

export default IndicatorCard;
